import * as React from "react";
import { Navigate, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
// import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import Chip from "@mui/material/Chip";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
// import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
// import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
// import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DoneIcon from "@mui/icons-material/Done";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, Avatar, CssBaseline } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { collection, query, where, getDocs, getFirestore } from "firebase/firestore";
import VideoUploadForm from "./forms/VideoUploadForm";
import { getUserData, logOut } from "../../services/authSlice";
import { getUserVideos } from "../../services/videosSlice";
import VideoCardPreview from "../../components/video/VideoCardPreview";
// import VideoIframe from "../iframe/VideoIframe";
import app from "../../services/firebaseinit";

const db = getFirestore(app);

const videosDb = "videos";
const drawerWidth = 240;
const columns = [
  { id: "name", label: "Video", minWidth: 170 },
  { id: "code", label: "Status", minWidth: 100 },
  {
    id: "population",
    label: "Visibility",
    minWidth: 170,
  },
  {
    id: "size",
    label: "Edit",
    minWidth: 170,
  },
  {
    id: "density",
    label: "Category",
    minWidth: 170,
  },
];

const VideoDashboard = (props) => {
  // drawer
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  // drawer
  const { uid, currentUser } = useSelector((state) => state.auth);
  const { uservideos } = useSelector((state) => state.videos);
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [editModeData, setEditModeData] = React.useState({});
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // const hundleSetFilters = async (userId, condition) => {
  //   const videosList = [];
  //   try {
  //     const q = query(collection(db, videosDb), where("user_id", "==", userId), where("in_review", "==", condition));

  //     const querySnapshot = await getDocs(q);

  //     querySnapshot.forEach((doc) => {
  //       videosList.push(doc.data());
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   dispatch(getUserVideos(videosList));
  //   console.log(videosList);
  // };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const getVideos = async (userId) => {
    const videosList = [];
    try {
      const q = query(collection(db, videosDb), where("user_id", "==", userId));

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        videosList.push(doc.data());
      });
    } catch (error) {
      console.log(error);
    }
    dispatch(getUserVideos(videosList));
  };
  const handleLogOut = () => {
    dispatch(logOut({}));
    (<Navigate to="/portfoliax" />);
  };
  // dialog
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSetEditMode = (dataInEdit) => {
    setEditModeData(dataInEdit);
    setOpen(true);
    setScroll("paper");
  };
  const drawer =
    (
      <>
        <Toolbar />
        <Divider />
        <List>
          <ListItem button style={{ marginLeft: "25%", marginTop: "40%", marginRight: "25%", alignContent: "center", alignItems: "center" }}>
            <Box position="fixed" sx={{ height: 100 }}>
              <Avatar sx={{ height: 60, width: 60 }} alt={uid} src={currentUser.photoURL} />
            </Box>
          </ListItem>
          <ListItem style={{ marginLeft: "20%", marginRight: "25%" }}>
            <ListItemText primary="Your Creation" />
          </ListItem>
          <ListItem style={{ marginLeft: "20%", marginRight: "25%" }}>
            <ListItemText primary={currentUser.displayName} />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <DashboardOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          {/* <ListItem button onClick={(e) => { e.preventDefault(); hundleSetFilters(uid, true); }}>
                <ListItemIcon>
                  <AccessTimeOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="In Review" />
              </ListItem>
              <ListItem button>
                <ListItemIcon>
                  <ModeEditOutlineOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="In Draft" />
              </ListItem>
              <ListItem button>
                <ListItemIcon>
                  <VisibilityOffOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Declined" />
              </ListItem> */}
        </List>
        <Divider />
        <ListItem button onClick={handleLogOut}>
          <ListItemIcon>
            <LogoutOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </>
    );
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // end dialog
  React.useEffect(() => {
    if (uid !== undefined) {
      dispatch(getUserData("user"));
      getVideos(uid);
    }
  }, [0]);
  const container = window !== undefined ? () => window().document.body : undefined;
  return (
    uid === undefined ? (<Navigate to="/portfoliax" />) :
      (
        <Box sx={{ display: "flex" }}>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "#031B34", height: 70 }}>
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  <Link className="mx-4 cursor-pointer my-2 text-lg" to="/">PX Studio</Link>
                </Typography>
                <Button color="inherit">
                  <Avatar alt={uid} src={currentUser.photoURL} />
                </Button>
              </Toolbar>
            </AppBar>
          </Box>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
            }}
            open
          >
            {drawer}
          </Drawer>
          <CssBaseline sx={{ flexGrow: 1, bgcolor: "background.default", overflow: "hidden" }}>
            <Paper sx={{ width: "100%", overflow: "hidden", flexGrow: 1 }}>
              <TableContainer sx={{ marginTop: "2%", marginLeft: !mobileOpen ? "20%" : "-100px" }}>
                <Table stickyHeader aria-label="sticky table" className="pt-12">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" colSpan={3}>
                        You Content
                      </TableCell>
                      <TableCell align="left" colSpan={2}>
                        <Chip onClick={(e) => { e.preventDefault(); handleSetEditMode(); }} avatar={<Avatar><YouTubeIcon sx={{ color: "red" }} /></Avatar>} label="Upload Your Youtube Creation" />
                      </TableCell>
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                      >
                        <DialogTitle id="scroll-dialog-title">
                          <Toolbar>
                            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                              Video Upload
                            </Typography>
                            <Button color="inherit" onClick={handleClose}>
                              <CloseOutlinedIcon />
                            </Button>
                          </Toolbar>
                        </DialogTitle>
                        <DialogContent dividers={scroll === "paper"}>
                          <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            tabIndex={-1}
                          >
                            <VideoUploadForm currentUser={currentUser} editModeData={editModeData} />
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleClose}>Close</Button>
                        </DialogActions>
                      </Dialog>

                    </TableRow>
                    <TableRow>
                      {columns.map((column, i) => (
                        <TableCell
                          key={i}
                          align="justify"
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ height: 100 }}>
                    {uservideos && uservideos
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, i) => (
                        <TableRow hover tabIndex={-1} key={i}>
                          <TableCell align="left" sx={{ width: 350, height: 30 }}>
                            {/* <Card sx={{ maxWidth: 280, maxHeight: 350 }}>
                              <VideoIframe videourl={row.videourl} heigh="5" wid="50" />
                            </Card> */}
                            <VideoCardPreview
                              username={row.username}
                              profileurl={row.profileurl}
                              videourl={row.videourl}
                            />
                          </TableCell>
                          <TableCell align="left" sx={{ width: 50 }}>
                            {row.review_status}
                          </TableCell>
                          <TableCell align="left" sx={{ width: 50 }}>
                            {row.is_approved ? "Approved" : "No Approved"}
                          </TableCell>
                          <TableCell align="left" onClick={(e) => { e.preventDefault(); handleSetEditMode(row); }} sx={{ width: 50 }}>
                            <ModeEditOutlineOutlinedIcon sx={{ color: "#031B34" }} />
                          </TableCell>
                          <TableCell align="left" sx={{ width: 300 }}>
                            <Chip label={row.category} variant="outlined" onDelete={{}} deleteIcon={<DoneIcon />} />
                          </TableCell>
                        </TableRow>
                      ))}
                    {uservideos && (
                      <TablePagination
                        rowsPerPageOptions={[1, 3, 5, 10, 25, 100, 250, 500]}
                        component="div"
                        count={uservideos.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ marginLeft: "-20px" }}
                      />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </CssBaseline>
        </Box>
      )
  );
};

export default VideoDashboard;